import { render } from "./blog_single.vue?vue&type=template&id=658a4826"
import script from "./blog_single.vue?vue&type=script&lang=js"
export * from "./blog_single.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__